import _ from 'underscore';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import cx from 'classnames';

import styles from './styles.module.scss';

const FilterModal = ({ children, modalStatus }) => {
	useEffect(() => {
		if (modalStatus) {
			document.body.style.overflow = 'hidden';
		} else {
			document.body.style.overflow = 'scroll';
		}
		return () => {
			document.body.style.overflow = 'scroll';
		};
	}, [modalStatus]);

	return ReactDOM.createPortal(
		<>
			<div
				className={cx(styles.FilterModal, {
					[styles.FilterModal_show]: modalStatus
				})}
			>
				{children}
			</div>
			<div
				className={cx(styles.FilterModal__Overlay, {
					[styles.FilterModal_show]: modalStatus
				})}
			></div>
		</>,
		document.body
	);
};

FilterModal.propTypes = {
	children: PropTypes.node,
	modalStatus: PropTypes.bool,
	switchFilter: PropTypes.func,
	modalHandler: PropTypes.func,
	filterTitle: PropTypes.string
};

FilterModal.defaultProps = {
	switchFilter: _.noop,
	modalHandler: _.noop,
	filterTitle: null
};

export default FilterModal;
